import axios from "axios";
import { getApiBaseUrl } from "@/utils/RuntimeConfig";

const auth = {
  /**
   * 从URL参数中获取accessKey并调用API获取token
   * @returns {Promise<string|null>} 返回获取到的token，失败返回null
   */
  async getTokenByAccessKey() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const userCode = urlParams.get('user');
      const keyCode = urlParams.get('accessKey');
      console.log("user", userCode);

      const response = {};

      if (userCode){
        console.log('get accessName', userCode);
        this.response = await axios({
          url: "/api/v1/user/loginInfoByAccessName",
          method: "POST",
          baseURL: getApiBaseUrl(),
          headers:{
            "accessName": userCode,
            "ClientType": 'ADMIN'
          }
        })
      } else if(keyCode) {
        console.log('get accessKey', keyCode);
        this.response = await axios({
          url: "/api/v1/user/loginInfo",
          method: "POST",
          baseURL: getApiBaseUrl(),
          headers: {
            "accessKey": keyCode,
            "ClientType": 'ADMIN'
          }
        })
      } else {
        // 如果没有accessKey，直接返回null
        console.log("URL中未找到accessName参数,accessKey参数");
        return null;
      }

      // 检查响应
      if (this.response.data && this.response.data.data) {
        const result = this.response.data.data;
        const token = result.token;
        let menusList=[];

        for (let i=0;i<result.menus.length;i++){
          menusList.push(result.menus[i].menuCode)
        }

        localStorage.setItem("token", token);
        sessionStorage.setItem("token", token);

        localStorage.setItem("menusList", JSON.stringify(menusList));
        localStorage.setItem("userName", result.userName);
        localStorage.setItem("userId", result.userId);
        localStorage.setItem("deptId", result.deptId);

        // 清理URL中的accessKey参数
        const cleanUrl = window.location.pathname + window.location.hash;
        window.history.replaceState({}, document.title, cleanUrl);

        console.log("getTokenByAccessKey ✅ 已成功通过accessKey获取token并存储到sessionStorage");
        return token;
      } else {
        console.error("getTokenByAccessKey 获取token失败：响应数据格式不正确", response.data);
        return null;
      }
    } catch (error) {
      console.error("getTokenByAccessKey 获取token时发生错误:", error);
      return null;
    }
  },

  getTokenFromUrl() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const tokenFromUrl = urlParams.get("token");

      if (tokenFromUrl) {
        // JWT格式验证
        const isValidFormat = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/.test(tokenFromUrl);

        if (!isValidFormat) {
          console.error("❌ URL参数token格式非法");
          return null;
        }

        sessionStorage.setItem("token", tokenFromUrl);

        // 清理URL
        const cleanUrl = window.location.pathname + window.location.hash;
        window.history.replaceState({}, document.title, cleanUrl);

        console.log("✅ Token已从URL参数自动注入sessionStorage");
        return tokenFromUrl;
      }
    } catch (error) {
      console.error("获取URL参数token失败:", error);
    }
    return null;
  },

  async getToken() {
    const urlParams = new URLSearchParams(window.location.search);
    const userCode = urlParams.get('user');
    const keyCode = urlParams.get('accessKey');
    const tokenFromUrl = urlParams.get("token");

    if (keyCode || userCode) {
      const tokenFromAccessKey = await this.getTokenByAccessKey();
      console.log("getToken tokenFromAccessKey", tokenFromAccessKey)
      if (tokenFromAccessKey) {
        return tokenFromAccessKey;
      }
    }

    if (tokenFromUrl) {
      const token = this.getTokenFromUrl();
      console.log("getToken tokenFromUrl", token)
      if (token) {
        return token;
      }
    }

    const tokenFromStorage = this.getLocalStorageToken();
    console.log("getToken tokenFromStorage", tokenFromStorage)
    if (tokenFromStorage) {
      return tokenFromStorage;
    }

    console.warn("⚠️ 未找到可用的token，请重新登录");
    return null;
  },

  getLocalStorageToken() {
    return localStorage.getItem("token");
  },

  /**
   * 统一退出登录：清除所有认证/会话缓存，跳转到登录页
   * @param {object} $router - Vue Router 实例（可选，不传时用 location.href 跳转）
   */
  logout($router) {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("url");
    localStorage.removeItem("token");
    localStorage.removeItem("menusList");
    localStorage.removeItem("userName");
    localStorage.removeItem("loginName");
    localStorage.removeItem("userId");
    localStorage.removeItem("deptId");
    localStorage.removeItem("editableTabs");
    localStorage.removeItem("editableTabsValue");
    if ($router) {
      $router.push("/login");
    } else {
      window.location.href = "/login";
    }
  }
}
export default auth;
